import * as React from "react";
import Autocomplete from "@mui/joy/Autocomplete";
import AutocompleteOption from "@mui/joy/AutocompleteOption";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import ListItemContent from "@mui/joy/ListItemContent";
import Typography from "@mui/joy/Typography";

// Define your API endpoint here
const apiEndpoint = "https://api.stemy.ai/api/search";

export const TrackPicker = ({ children }) => {
  const [options, setOptions] = React.useState([]); // Define the options state

  // Fetch autocomplete results
  const fetchTracks = async (inputValue) => {
    try {
      const response = await fetch(
        `${apiEndpoint}?q=${encodeURIComponent(inputValue)}`
      );
      const data = (await response.json()).data; // This line reads the stream and parses the JSON
      setOptions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch tracks:", error);
    }
  };

  // Effect to fetch countries when the component mounts
  React.useEffect(() => {
    fetchTracks("");
  }, []);

  return (
    <Autocomplete
      id="track-search"
      placeholder="Search for a track…"
      slotProps={{
        input: {
          autoComplete: "new-password", // disable autocomplete and autofill
        },
      }}
      sx={{ width: 300 }}
      options={options}
      autoHighlight
      size="lg"
      getOptionLabel={(option) => option.title}
      onInputChange={(event, newInputValue) => {
        // Fetch tracks from the API when the input value changes
        fetchTracks(newInputValue);
      }}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.id}>
          <ListItemDecorator>
            <img
              loading="lazy"
              width="40"
              // srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={option.album_img}
              alt=""
            />
          </ListItemDecorator>
          <ListItemContent sx={{ fontSize: "lg" }}>
            {option.title}
            <Typography level="sm">
              ({option.artist_name}) | {option.album_title}
            </Typography>
          </ListItemContent>
        </AutocompleteOption>
      )}
    />
  );
};
